import { AppMultiSelect, AppRemixIcon } from "@/layout/AppComponents";
import errorHandler from "@/layout/components/error/ErrorHandler";
import axios from "axios";
import { useCallback, useEffect, useState } from "react";
import ReactDOMServer from "react-dom/server";
import { useDispatch } from "react-redux";
import { useParams } from "react-router-dom";
import { axiosPath } from "../../../../routing/helpers/router";
import Translator from "../../helpers/Translator";
import useIsMounted from "../../hooks/useIsMounted";

export default function CategorySelect(props) {
  const {
    value,
    onHandleChange,
    className = "mb-2",
    isMulti = true,
    allowSelectAll = true,
    hasSearchBox = false,
    hasSelectOptions = false,
  } = props;
  const { moduleBridgeHex, plantHex } = useParams();
  const dispatch = useDispatch();
  const isMounted = useIsMounted();
  const [categories, setCategories] = useState();

  // > LOAD CATEGORIES //
  const loadCategories = useCallback(
    async () =>
      axios
        .post(
          axiosPath(
            plantHex
              ? "api_r_user_module_legalCompliance_evaluation_getCategories"
              : "api_r_user_module_globalLegalCompliance_evaluation_getCategories"
          ),
          { moduleBridgeHex, plantHex }
        )
        .then((r) => {
          if (isMounted.current) {
            setCategories(r.data);
          }
        })
        .catch((e) => dispatch(errorHandler(e))),

    [moduleBridgeHex, plantHex]
  );

  useEffect(() => {
    loadCategories();
  }, []);
  // < LOAD CATEGORIES //
  return (
    <AppMultiSelect
      options={categories}
      title={ReactDOMServer.renderToString(
        <Translator file="module-legalCompliance" name="module.lc.categories" />
      )}
      placeholder={ReactDOMServer.renderToString(
        <Translator file="user" name="select.one.or.multiple.categories" />
      )}
      value={value}
      onChange={(opt) => onHandleChange(opt)}
      isMulti={isMulti}
      icon={<AppRemixIcon icon="apps-2" />}
      allowSelectAll
      isLoading={!categories}
      hasSearchBox={hasSearchBox}
      hasSelectOptions={hasSelectOptions}
    />
  );
}
